import {Outlet} from "react-router-dom";

import Container from "../../сomponents/UI/Container";

import './CRMLayout.sass';

const CRMLayout = () => {
    return (
        <main className="local-bootstrap">
            <Container full>
                <Outlet />
            </Container>
        </main>
    )
};

export default CRMLayout;